const FJImagePreviewItem = () => {
    return <div>FJImagePreviewItem</div>;
};

export default FJImagePreviewItem;
